/* eslint-disable */
// PortalNoAccess — shown when a user reaches a portal route they aren't permitted
// for (Access-engine route enforcement). RLS already protects the data; this is the
// friendly UI when the deny-by-default gate blocks the route. Reused across portals.
import React from 'react';
import styles from './PortalNoAccess.module.css';

export default function PortalNoAccess({ portal = 'this portal' }) {
  return (
    <div className={styles.noAccess} style={{ maxWidth: 460, textAlign: 'center',
      background: 'var(--card-bg)', border: 'var(--border-thin) solid var(--border)', borderRadius: 'var(--radius-lg)' }}>
      <div style={{ fontSize: 38, marginBottom: 10 }}>🔒</div>
      <div style={{ fontSize: 'var(--text-md)', fontWeight: 'var(--weight-bold)', color: 'var(--text)' }}>No access to {portal}</div>
      <div style={{ fontSize: 'var(--text-xs)', color: 'var(--text-muted)', marginTop: 8, lineHeight: 1.6 }}>
        You don't have permission for this portal. Ask an admin to grant you access in Settings → Users.
      </div>
    </div>
  );
}
